<jmkw-legend-control-bar [legendParams]="legendParams" [id]="id!">
  @if (controlBarContent) {
    <ng-container
      right
      [ngTemplateOutlet]="controlBarContent!"
    ></ng-container>
  }
</jmkw-legend-control-bar>
<div class="projected-content-wrapper">
  <ng-container #legendHost></ng-container>
</div>
